import React from 'react';
import { useIntl } from 'react-intl';

import { SharedModalProps } from '../../types/SharedModalProps';
import { useModal } from './useModal';

type Callback = () => void;

/**
 * A DetailModal is a simple modal used to render details.  It never supports any actions.
 */
export const useDetailModal = (
  props: SharedModalProps,
): [React.ReactNode, Callback, Callback] => {
  const intl = useIntl();
  return useModal({
    ...props,
    // the following props should not be overwritable
    cancelText: intl.formatMessage({
      id: 'UseDetailModal.closeAction',
      defaultMessage: 'Close',
      description: 'Label for closing the modal',
    }),
    disableFooter: false,
    primaryAction: undefined,
    secondaryActions: [],
  });
};
